import { useCallback } from 'react';

import type { ResetPaymentBlock } from './types';

export function useResetPaymentBlock<T>(params: ResetPaymentBlock<T>) {
	const { orderId, isBlockedForPayment, resetBlock, refetchOrder, applyOrder, setLoading, setError } = params;

	const resetPaymentBlockAndRefetchOrder = useCallback(async (): Promise<boolean> => {
		if (!isBlockedForPayment) {
			return true;
		}

		setError?.(null);
		setLoading?.(true);

		try {
			await resetBlock(orderId);

			const order = await refetchOrder(orderId);

			if (!order) {
				setError?.(new Error('Order is empty'));

				return false;
			}

			applyOrder(order);

			return true;
		} catch (error) {
			console.error(error);
			setError?.(error);

			return false;
		} finally {
			setLoading?.(false);
		}
	}, [orderId, isBlockedForPayment, resetBlock, refetchOrder, applyOrder, setLoading, setError]);

	return { resetPaymentBlockAndRefetchOrder };
}
